import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import { Toaster } from "@/components/ui/sonner";

// Pages
import LandingPage from "@/pages/LandingPage";
import ProductsPage from "@/pages/ProductsPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import ArtisansPage from "@/pages/ArtisansPage";
import ArtisanDetailPage from "@/pages/ArtisanDetailPage";
import CartPage from "@/pages/CartPage";
import CheckoutSuccessPage from "@/pages/CheckoutSuccessPage";
import ImpactDashboard from "@/pages/ImpactDashboard";
import AdminPage from "@/pages/AdminPage";
import IrisAuthPage from "@/pages/IrisAuthPage";
import CertifyPage from "@/pages/CertifyPage";
import ScanPage from "@/pages/ScanPage";
import PassportPage from "@/pages/PassportPage";

// New B2B Pages
import CompanyRegisterPage from "@/pages/CompanyRegisterPage";
import CompanyDashboardPage from "@/pages/CompanyDashboardPage";
import AuditorPortalPage from "@/pages/AuditorPortalPage";
import SupplyChainPage from "@/pages/SupplyChainPage";
import DocsPage from "@/pages/APIDocsPage";
import WalletPage from "@/pages/WalletPage";
import ReferralPage from "@/pages/ReferralPage";
import CarbonDashboardPage from "@/pages/CarbonDashboardPage";
import AchievementsPage from "@/pages/AchievementsPage";
import WorkflowGuidePage from "@/pages/WorkflowGuidePage";
import SellerProfilePage from "@/pages/SellerProfilePage";
import MyProfilePage from "@/pages/MyProfilePage";
import LoginPage from "@/pages/LoginPage";

// Context
import { CartProvider } from "@/context/CartContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const seedDatabase = async () => {
  try {
    await axios.post(`${API}/seed`);
  } catch (seedError) {
    // Seed endpoint may not exist or already seeded - this is expected
    console.debug('Database seed skipped:', seedError.message);
  }
};

function App() {
  useEffect(() => {
    seedDatabase();
  }, []);

  return (
    <CartProvider>
      <div className="App min-h-screen bg-background">
        <BrowserRouter>
          <Routes>
            {/* Consumer Routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/products/:id" element={<ProductDetailPage />} />
            <Route path="/artisans" element={<ArtisansPage />} />
            <Route path="/artisans/:id" element={<ArtisanDetailPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
            <Route path="/impact" element={<ImpactDashboard />} />
            <Route path="/admin" element={<AdminPage />} />
            
            {/* Certification Routes */}
            <Route path="/iris-auth" element={<IrisAuthPage />} />
            <Route path="/certify" element={<CertifyPage />} />
            <Route path="/scan" element={<ScanPage />} />
            <Route path="/passport/:id" element={<PassportPage />} />
            
            {/* B2B Platform Routes */}
            <Route path="/company/register" element={<CompanyRegisterPage />} />
            <Route path="/company/dashboard" element={<CompanyDashboardPage />} />
            <Route path="/company/dashboard/:companyId" element={<CompanyDashboardPage />} />
            <Route path="/auditors" element={<AuditorPortalPage />} />
            <Route path="/supply-chain/:certificateId" element={<SupplyChainPage />} />
            <Route path="/docs" element={<DocsPage />} />
            <Route path="/wallet" element={<WalletPage />} />
            <Route path="/referral" element={<ReferralPage />} />
            <Route path="/carbon" element={<CarbonDashboardPage />} />
            <Route path="/achievements" element={<AchievementsPage />} />
            <Route path="/guide" element={<WorkflowGuidePage />} />
            <Route path="/seller/:sellerId" element={<SellerProfilePage />} />
            <Route path="/profile" element={<MyProfilePage />} />
            <Route path="/my-profile" element={<MyProfilePage />} />
            <Route path="/login" element={<LoginPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" />
      </div>
    </CartProvider>
  );
}

export default App;
